import { NavArrowContainer, NavigationArrow } from "../../assets/styles/generalStyles";
import ArrowU from '../../assets/icons/arrow-up.png';

export function ArrowToTop() {
    return (
        <NavArrowContainer>
            <NavigationArrow src={ArrowU} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} />
        </NavArrowContainer>
    )
}